import { useEffect, useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import { useLocation, Link } from 'react-router-dom'
import SEO from '../components/SEO'

const archetypes = [
  {
    id: 'player-bloccato',
    name: 'Il Player Bloccato',
    desc: 'Hai un potenziale enorme e una mente intelligente, ma vivi in una perenne "safe zone" dopaminergica virtuale. Consumi più contenuti di quanti ne crei, studi infinite tecniche di produttività, ma al momento di premere "Start" la tua barra dell\'Azione reale offline si blocca per paura o per distrazione.',
    strengths: 'Grande visione strategica, eccellente creatività, capacità di analizzare problemi complessi e amore per la progressione (che per ora applichi solo nei videogiochi).',
    debuffs: 'Paralisi da Analisi (Livello Max), Scrolling Dopaminergico Incontrollato, Evitamento delle quest reali scomode.',
    quest: 'La Quest "Sveglia Analogica": per i primi 30 minuti del mattino, lo smartphone rimane spento in un\'altra stanza. Bevi un bicchiere d\'acqua ed esegui 5 minuti di camminata reale o respirazione prima di sbloccare il primo schermo.',
    stats: { Focus: 40, Energia: 35, Azione: 20, Coraggio: 30 },
    color: '#8b5cf6',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4l3 3" />
      </svg>
    ),
  },
  {
    id: 'mago-bruciato',
    name: 'Il Mago Bruciato',
    desc: 'Hai la testa piena di idee geniali, progetti alternativi, startup o sceneggiature. Studi costantemente cose nuove, ma la tua barra del "Mana" (l\'energia cognitiva) è a zero. Soffri di stanchezza cronica e Brain Fog perché tieni aperti troppi loop mentali contemporaneamente senza mai portarne uno a termine.',
    strengths: 'Curiosità intellettuale infinita, apprendimento ultra-rapido di nuove abilità, forte inventiva e pensiero laterale.',
    debuffs: 'Mana Esaurito (Stanchezza mentale cronica), Dispersione energetica totale, Ansia da multi-tasking caotico.',
    quest: 'La Quest "Monaco del Task Singolo": archivia temporaneamente tutte le idee tranne una. Dedica 25 minuti al giorno (1 Pomodoro singolo) esclusivamente a quell\'unico progetto per 14 giorni consecutivi, senza aprire altre schede.',
    stats: { Focus: 25, Energia: 20, Azione: 30, Coraggio: 45 },
    color: '#00d4ff',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path d="M12 2L2 12l10 10 10-10L12 2z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
  },
  {
    id: 'tank-silenzioso',
    name: 'Il Tank Silenzioso',
    desc: 'Sei la roccia del party. Lavori o studi senza sosta, sopporti livelli indicibili di stress e fatica senza mai lamentarti o chiedere aiuto. Tuttavia, accumuli tensione nel tuo corpo ignorando i segnali fisici di allarme, rischiando un improvviso e devastante burnout psicosomatico.',
    strengths: 'Resilienza d\'acciaio, affidabilità incrollabile, lealtà estrema verso il party e grandissima etica del dovere.',
    debuffs: 'Isolamento da Party (rifiuto di farsi aiutare), Accumulo tossico di cortisolo, Difficoltà cronica a dire "No".',
    quest: 'La Quest "Scarico del Calore": pianifica 30 minuti quotidiani di disconnessione totale senza cuffie, schermi o musica. Pratica attività fisica rilassante ed esercitati a dire "No" a un carico di lavoro non prioritario questa settimana.',
    stats: { Focus: 55, Energia: 40, Azione: 50, Coraggio: 35 },
    color: '#ef4444',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
  },
  {
    id: 'rogue-invisibile',
    name: 'Il Rogue Invisibile',
    desc: 'Sei estremamente abile, preparato e possiedi un talento innato. Tuttavia, ti nascondi nell\'ombra. Eviti a tutti i costi l\'esposizione pubblica, i feedback esterni o il giudizio degli altri. La paura paralizzante di fallire in pubblico ti spinge ad agire solo dietro le quinte, rallentando la tua evoluzione reale.',
    strengths: 'Precisione chirurgica, eccezionale capacità di analisi e pianificazione strategica avanzata prima di agire.',
    debuffs: 'Sindrome dell\'Impostore acuta, Evitamento del confronto reale, Paura del giudizio sociale e della visibilità.',
    quest: 'La Quest "Esposizione Controllata": questa settimana pubblica un piccolo lavoro imperfetto, esprimi apertamente la tua opinione in una riunione o fai una domanda in pubblico. Allena la tolleranza all\'esposizione.',
    stats: { Focus: 60, Energia: 30, Azione: 25, Coraggio: 20 },
    color: '#9ca3af',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
  },
  {
    id: 'chierico-degli-altri',
    name: 'Il Chierico degli Altri',
    desc: 'Sei il supporto ideale del gruppo. Risolvi le emergenze di amici, colleghi e familiari, doni consigli perfetti e spendi tutta la tua energia per far avanzare gli altri. Purtroppo, la tua "Questline principale" reale è ferma al Livello 1, poiché usi i problemi altrui come alibi per non affrontare i tuoi.',
    strengths: 'Empatia straordinaria, problem-solving relazionale eccezionale, forte predisposizione all\'ascolto e all\'unione.',
    debuffs: 'Sindrome del Salvatore, Procrastinazione altruistica (mettere gli altri davanti a sé per evitare di guardarsi dentro).',
    quest: 'La Quest "Golden Hour di Respawn": dedica la prima ora del tuo mattino lavorativo o di studio esclusivamente a un tuo traguardo personale (salute, studio, progetto secondario) prima di rispondere a messaggi o email altrui.',
    stats: { Focus: 45, Energia: 25, Azione: 55, Coraggio: 40 },
    color: '#facc15',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
    ),
  },
]

function ArchetypeCard({ archetype, index, isActive }) {
  const cardRef = useRef(null)
  const isInView = useInView(cardRef, { once: true, margin: '-50px' })

  const handleMouseMove = (e) => {
    const card = cardRef.current
    if (!card) return
    const rect = card.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top
    const cx = rect.width / 2
    const cy = rect.height / 2
    card.style.transform = `perspective(1000px) rotateX(${(y - cy) / 25}deg) rotateY(${(cx - x) / 25}deg) scale3d(1.01,1.01,1.01)`
  }
  const handleMouseLeave = () => {
    const card = cardRef.current
    if (card) card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale3d(1,1,1)'
  }

  // Neon pulsing border when actively selected via hash anchor
  const activeStyle = isActive ? {
    borderColor: archetype.color,
    boxShadow: `0 0 35px ${archetype.color}35, inset 0 0 15px ${archetype.color}15`,
    transform: 'scale(1.02)'
  } : {
    borderColor: 'rgba(139,92,246,0.15)'
  }

  return (
    <motion.div
      ref={cardRef}
      id={archetype.id}
      className={`manga-panel rounded-2xl p-6 md:p-8 relative overflow-hidden transition-all duration-300 ${isActive ? 'ring-2' : ''}`}
      style={{
        ...activeStyle,
        background: 'rgba(5, 5, 20, 0.75)',
        borderWidth: '1px',
        borderStyle: 'solid',
        scrollMarginTop: '100px'
      }}
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {/* Absolute top neon border glow */}
      <div className="absolute top-0 left-0 w-full h-[2px]" style={{ background: `linear-gradient(90deg, transparent, ${archetype.color}, transparent)` }} />

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
        
        {/* Sinistra: Info Generali & Statistiche */}
        <div className="lg:col-span-5 space-y-6">
          <div className="flex items-center gap-4">
            <div
              className="w-14 h-14 rounded-xl flex items-center justify-center shrink-0 border border-nerd-purple/20"
              style={{ color: archetype.color, background: `${archetype.color}10` }}
            >
              {archetype.icon}
            </div>
            <div>
              <h2 className="font-display text-xl md:text-2xl font-bold text-nerd-white group-hover:text-gradient">
                {archetype.name}
              </h2>
              <span className="text-[9px] text-nerd-gray uppercase tracking-widest font-display block mt-0.5">
                Archetipo Sbloccato · Classe {String(index + 1).padStart(2, '0')}
              </span>
            </div>
          </div>

          <div className="space-y-3 bg-nerd-dark/45 p-4 rounded-xl border border-nerd-purple/10">
            <span className="text-[10px] text-nerd-cyan uppercase font-display block tracking-widest mb-1">
              STATISTICHE DI PARTENZA:
            </span>
            {Object.entries(archetype.stats).map(([k, v]) => (
              <div key={k} className="flex items-center gap-2">
                <span className="text-[9px] text-nerd-gray uppercase w-16 shrink-0 font-display">{k}</span>
                <div className="flex-1 h-1.5 bg-nerd-bg rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full"
                    style={{ width: `${v}%`, background: `linear-gradient(90deg, ${archetype.color}60, ${archetype.color})` }}
                  />
                </div>
                <span className="text-[10px] font-display w-8 text-right" style={{ color: archetype.color }}>{v}%</span>
              </div>
            ))}
          </div>
        </div>

        {/* Destra: Analisi Immersiva, Punti di Forza, Debuff & Quest */}
        <div className="lg:col-span-7 space-y-5">
          <div>
            <span className="text-[9px] text-nerd-cyan uppercase font-display tracking-widest block mb-1">ANALISI DELLA CLASSE:</span>
            <p className="text-nerd-gray text-xs md:text-sm leading-relaxed font-body">
              {archetype.desc}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="bg-nerd-dark/30 p-3 rounded-lg border border-nerd-cyan/10">
              <span className="text-[9px] text-nerd-cyan uppercase font-display tracking-widest block mb-1 font-bold">✨ Punti di Forza (Skill):</span>
              <p className="text-nerd-gray text-[11px] leading-relaxed font-body">{archetype.strengths}</p>
            </div>
            <div className="bg-nerd-dark/30 p-3 rounded-lg border border-red-500/10">
              <span className="text-[9px] text-red-400 uppercase font-display tracking-widest block mb-1 font-bold">⚠️ Debuff Attivi (Blocchi):</span>
              <p className="text-nerd-gray text-[11px] leading-relaxed font-body">{archetype.debuffs}</p>
            </div>
          </div>

          {/* Quest di Sblocco - Retroilluminata e in rilievo */}
          <div
            className="p-4 rounded-xl relative overflow-hidden"
            style={{
              border: `1px solid ${archetype.color}35`,
              background: `linear-gradient(135deg, rgba(5,5,20,0.9), ${archetype.color}08)`
            }}
          >
            <div className="flex gap-2.5 items-start">
              <span className="text-base shrink-0 mt-0.5">⚔️</span>
              <div className="space-y-1">
                <span className="text-[10px] uppercase font-display tracking-widest block font-bold" style={{ color: archetype.color }}>
                  QUEST DI SBLOCCO REALE (RESPAWN):
                </span>
                <p className="text-nerd-white text-xs leading-relaxed font-body">
                  {archetype.quest}
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </motion.div>
  )
}

export default function ArchetypesPage() {
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' })
  const { hash } = useLocation()

  // Automatic scrolling to archetype element if hash is present in URL
  useEffect(() => {
    if (hash) {
      const elementId = hash.replace('#', '')
      const element = document.getElementById(elementId)
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }, 300)
      }
    }
  }, [hash])

  return (
    <div className="min-h-screen pt-32 pb-24 px-4 bg-nerd-bg">
      <SEO 
        title="Dossier Archetipi | Scopri e Sblocca la tua Classe"
        description="Analisi approfondita dei 5 archetipi psicologici del procrastinatore nerd. Identifica i tuoi debuff, scopri i tuoi punti di forza in-game e sblocca la tua quest evolutiva reale."
      />
      <div className="max-w-5xl mx-auto space-y-12">
        
        {/* Header */}
        <motion.div
          ref={sectionRef}
          className="text-center space-y-4 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-block px-3 py-1 rounded bg-nerd-purple/10 border border-nerd-purple/30">
            <span className="text-[9px] uppercase tracking-widest text-nerd-cyan font-display font-bold">
              📂 DOSSIER CLASSI DI GIOCO
            </span>
          </div>
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-nerd-white">
            Analisi degli <span className="text-gradient">Archetipi.</span>
          </h1>
          <p className="text-nerd-gray text-sm md:text-base leading-relaxed font-body">
            Non sei rotto né difettoso. Hai semplicemente affrontato il dungeon della vita reale senza conoscere la tua scheda personaggio e senza un equipaggiamento adatto. Trova la tua classe ed esegui la tua Quest.
          </p>
        </motion.div>

        {/* Archetypes Detailed List */}
        <div className="space-y-8 pt-4">
          {archetypes.map((a, i) => (
            <ArchetypeCard
              key={a.id}
              archetype={a}
              index={i}
              isActive={hash === `#${a.id}`}
            />
          ))}
        </div>

        {/* Back to CTA Game */}
        <motion.div
          className="text-center pt-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <p className="text-nerd-gray text-xs md:text-sm font-body mb-4">
            Non sei sicuro di quale sia la tua classe principale?
          </p>
          <Link
            to="/#lead-game"
            className="py-3 px-8 nerd-btn-primary font-display text-xs font-bold uppercase tracking-wider transition-all duration-300 inline-block"
            style={{ boxShadow: '0 4px 15px rgba(139, 92, 246, 0.4)' }}
          >
            Gioca il Libro-Game in Homepage →
          </Link>
        </motion.div>
      </div>
    </div>
  )
}
